import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { createMarkup } from "lib/helpers";

class DefaultValueCell implements ICellRendererComp {
    declare eGui: HTMLElement;

    private buildBaseElement(params: ICellRendererParams) {
        this.eGui = document.createElement("div");
        this.eGui.className = "defaultValueHeader";
        const defaultColumn = document.createElement("div");
        defaultColumn.className = "defaultValue";
        defaultColumn.innerHTML = createMarkup(params.valueFormatted || params.value || "");
        this.eGui.appendChild(defaultColumn);
    }

    refresh(params: ICellRendererParams): boolean {
        // return true to tell the grid we refreshed successfully
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(params: ICellRendererParams) {
        this.buildBaseElement(params);
    }
}

export { DefaultValueCell };
